var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_1515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7296 14.1603C21.1019 14.1603 20.5945 14.6689 20.5945 15.2953V24.3765C20.5945 25.0019 20.0859 25.5115 19.4595 25.5115H3.56751C2.94085 25.5115 2.43245 25.0019 2.43245 24.3765V8.48451C2.43245 7.85909 2.94085 7.34944 3.56751 7.34944H12.6487C13.2764 7.34944 13.7837 6.84083 13.7837 6.21438C13.7837 5.58771 13.2764 5.0791 12.6487 5.0791H3.56751C1.69001 5.0791 0.162109 6.607 0.162109 8.48451V24.3765C0.162109 26.254 1.69001 27.7819 3.56751 27.7819H19.4595C21.337 27.7819 22.8649 26.254 22.8649 24.3765V15.2953C22.8649 14.6676 22.3573 14.1603 21.7296 14.1603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.805 13.1262C10.7256 13.2056 10.6721 13.3066 10.6495 13.4155L9.84699 17.4295C9.80957 17.6155 9.8686 17.8074 10.0025 17.9425C10.1103 18.0504 10.2556 18.1081 10.4044 18.1081C10.4406 18.1081 10.4782 18.1048 10.5156 18.0969L14.5284 17.2944C14.6396 17.2715 14.7406 17.2183 14.819 17.1387L23.8001 8.15755L19.7874 4.14502L10.805 13.1262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5744 1.36965C25.4678 0.262851 23.6674 0.262851 22.5616 1.36965L20.9907 2.94058L25.0035 6.95332L26.5744 5.38218C27.1102 4.84759 27.4054 4.13467 27.4054 3.37644C27.4054 2.6182 27.1102 1.90528 26.5744 1.36965Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_1515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.2432,
    height: 27.2432,
    fill: "white",
    transform: "translate(0.162109 0.486328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.314192631e92078765594bf0262a53a2.svg";
export { ForwardRef as ReactComponent };